import configurations from '../../misc/configurations'

const validate = values => {
	const errors = {}

	if (!values.organization_name) {
		errors.organization_name = "Organization name can't be blank"
	}
	if (!values.admin_name) {
		errors.admin_name = "Admin name can't be blank"
	}
	if (!values.admin_email) {
		errors.admin_email = "Admin email can't be blank"
	} else if (!configurations.emailRegex.test(values.admin_email)) {
		errors.admin_email = 'Invalid email format'
	}
	if (!values.account_type) {
		errors.account_type = "Account type can't be blank"
	}
	if (!values.country) {
		errors.country = "Country can't be blank"
	}

	return errors
}

export default validate
